/**
 * RhythmProgress — calm, non-gamified rhythm indicator
 * "You've completed X resets this month" or "You've kept your rhythm going"
 * Placed on Dashboard + Review & Reset
 */
import { usePrivacy } from "../privacy/PrivacyProvider";
import { RotateCcw } from "lucide-react";

export function RhythmProgress() {
  const { sharedProgress, isSolo, together } = usePrivacy();

  const resets = sharedProgress?.resets_this_month ?? 0;
  if (resets === 0) return null;

  const message =
    resets === 1
      ? "You've completed 1 reset this month"
      : `You've completed ${resets} resets this month`;

  return (
    <div
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[#1a4d3e]/5 border border-[#1a4d3e]/10"
      data-testid="rhythm-progress"
    >
      <RotateCcw className="w-3.5 h-3.5 text-[#1a4d3e]" />
      <span className="text-xs text-[#1a4d3e] font-medium">{message}</span>
    </div>
  );
}
